import { FormBadgePreviewModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class BadgePreviewEditor extends AbstractElementEditor<FormBadgePreviewModel> {
  public getDescription(): string {
    return 'Let users see how their badge will look';
  }

  public getName(): string {
    return 'Badge Preview';
  }

  public getIcon(): string {
    return 'badge';
  }
}
